import { getPlatforms } from '@ionic/vue';
import { Capacitor } from '@capacitor/core';

// 导出一个名为 canSetupNativePlugin 的函数
export function canSetupNativePlugin() {
  const platforms = getPlatforms();
  const canSetupPlugin =
    !platforms.includes('mobileweb') && !platforms.includes('desktop');
  return canSetupPlugin;
}

//  iOS 1, Android 2, Windows 3, OSX 4, WEB 5, 小程序 6，linux 7
const platformMap = {
  ios: 1,
  android: 2,
  windows: 3,
  osx: 4,
  web: 5,
};

type PlatformType = keyof typeof platformMap;

export const getOpenImPlatform = () => {
  // 判断当前平台类型
  const platform = Capacitor.getPlatform() as PlatformType; // 返回值：'web'、'ios'、'android'
  return platformMap[platform];
  // if (isIos()) {
  //   return platformMap['ios'];
  // } else if (isAndroid()) {
  //   return platformMap['android'];
  // } else {
  //   return platformMap['web'];
  // }
};
